type NovaLogoProps = {
  compact?: boolean
}

export function NovaLogo({ compact = false }: NovaLogoProps) {
  return (
    <span
      className={`nova-logo${compact ? ' nova-logo--compact' : ''}`}
      role="img"
      aria-label="Nova Energy"
    >
      <span className="nova-logo__wordmark" aria-hidden="true">
        <img
          src={`${import.meta.env.BASE_URL}media/nova-logo.png`}
          alt=""
          width="1254"
          height="1254"
          decoding="async"
        />
      </span>
      {!compact ? <span className="nova-logo__energy">ENERGY</span> : null}
    </span>
  )
}
